'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _IDTextbox2 = require('./IDTextbox');

var _IDTextbox3 = _interopRequireDefault(_IDTextbox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDEmail = function (_IDTextbox) {
    (0, _inherits3.default)(IDEmail, _IDTextbox);

    function IDEmail() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, IDEmail);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IDEmail.__proto__ || (0, _getPrototypeOf2.default)(IDEmail)).call.apply(_ref, [this].concat(args))), _this), _this.dataTestID = 'email', _this.inputType = 'email', _this.focus = false, _this.onValidate = function (value) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(String(value).toLowerCase())) {
                _this.iconInput && _this.iconInput.openTooltip();
            } else {
                _this.iconInput && _this.iconInput.closeTooltip();
            }
        }, _this.handleChange = function (event) {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                readOnly = _this$props.readOnly;

            if (disabled || readOnly) {
                return;
            }
            var value = event.target.value;
            _this.updateValue(value, value);
            if (_this.focus) {
                _this.onValidate(value);
            }
        }, _this.handleBlur = function () {
            _this.Placeholder && _this.Placeholder.show();
            var onBlur = _this.props.onBlur;
            var value = _this.state.value;

            _this.focus = true;
            _this.onValidate(value);
            onBlur && onBlur(true);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return IDEmail;
}(_IDTextbox3.default);

exports.default = IDEmail;


IDEmail.defaultProps = (0, _extends3.default)({}, _IDTextbox3.default.defaultProps, {
    iconCls: '',
    iconType: "mail",
    tooltip: "Invalid email"
});